import styled from '@emotion/styled';
import { mqUser } from 'utils/responsive';

export type TabType = 'all' | 'seller' | 'buyer';

interface TabItem {
    key: TabType;
    label: string;
}

interface TabProps {
    activeTab: TabType;
    onTabChange: (tab: TabType) => void;
    tabs?: TabItem[];
}

const TabContainer = styled.div`
    display: flex;
    gap: 0;
    border-bottom: 2px solid #e0e0e0;
`;

const Tab = styled.button<{ active: boolean }>`
    background: none;
    border: none;
    padding: 12px 24px;
    font-size: var(--font-medium);
    font-weight: var(--font-bold);
    cursor: pointer;
    color: ${(props) => (props.active ? 'var(--main-color-blue)' : '#666')};
    border-bottom: 2px solid ${(props) => (props.active ? 'var(--main-color-blue)' : 'transparent')};
    transition: all 0.2s ease;

    &:hover {
        color: var(--main-color-blue);
        background-color: #f8f9fd;
    }

    ${mqUser('SP')} {
        padding: 10px 16px;
        font-size: var(--font-small);
    }
`;

const defaultTabs: TabItem[] = [
    { key: 'all', label: '全て' },
    { key: 'seller', label: '売り手' },
    { key: 'buyer', label: '買い手' },
];

export const UserTypeTab: React.FC<TabProps> = ({ activeTab, onTabChange, tabs = defaultTabs }) => {
    return (
        <TabContainer>
            {tabs.map((tab) => (
                <Tab key={tab.key} active={activeTab === tab.key} onClick={() => onTabChange(tab.key)}>
                    {tab.label}
                </Tab>
            ))}
        </TabContainer>
    );
};
